import React from 'react';
import { Breakpoints, mediaBreakpoints } from '~/styles/media';
import useWindowSize from '~/hooks/useWindowSize';

const useBreakpoint = (): Breakpoints => {
  const { width } = useWindowSize();
  if (width === undefined) return Breakpoints.fallback;
  if (width <= mediaBreakpoints[Breakpoints.mobile]) return Breakpoints.mobile;
  if (width <= mediaBreakpoints[Breakpoints.tablet]) return Breakpoints.tablet;
  return Breakpoints.fallback;
};

export default useBreakpoint;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type BreakpointValues = Partial<Record<keyof typeof Breakpoints, any>> & { fallback: any };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useBreakpointValue = (values: BreakpointValues = {} as BreakpointValues): any => {
  const breakpoint = useBreakpoint();
  return React.useMemo(() => (values[breakpoint] || values.fallback), [values, breakpoint]);
};
